import styled from 'styled-components';

const DrawWrapper = styled.div`
  min-height: calc(100vh - 62px);
  width: 300px;
  min-width: 300px;
  margin-right: ${p => (p.isOpen ? 0 : '-300px')};
  transition: margin 0.25s ease-in-out;
  box-sizing: border-box;
  position: relative;
`;

const FixedDrawContent = styled.div`
  width: 100%;
  height: 100%;
  color: ${p => p.theme.color.text};
  background: white;
  border-left: 1px solid ${p => p.theme.color.border};
  position: absolute;
`;

const CaptionSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 1em;
  height: 51px;
  border-bottom: 1px solid ${p => p.theme.color.border};
  img {
    width: 14px;
    height: 14px;
    transition: opacity 0.25s ease-in-out;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
`;

const SectionContent = styled.div`
  height: calc(100% - 51px);
  width: 100%;
  overflow: auto;
  scroll-behavior: auto;
  position: absolute;
  > div:nth-child(even) {
    background: ${p => p.theme.color.background};
  }
`;

export default { DrawWrapper, FixedDrawContent, CaptionSection, SectionContent };
